import React from 'react';
import PropTypes from 'prop-types';

// constants
import gasIcon from '@drivesally/sally-fn/lib/gas/constants/icon.const.gas';

// components
import {Modal} from '@drivesally/sally-ui';
import Loader from '../../../components/components/atoms/Loader/Loader';

// print components
import Print from '../../../print/components/Print/Print';

// lib
import humanizeGasType from '../../lib/humanizeType.lib.gas';

const GasModal = ({loading, visible, gas, children, onClose}) => {
  return (
    <Print
      trigger={({print}) => (
        <Modal
          visible={visible}
          title={!!gas ? gas.vehicle.svid : 'Gas'}
          subtitle={humanizeGasType(gas?.type)}
          size="full"
          icon={gasIcon}
          onClose={onClose}
          disableOutsideClickClose
          headerActions={[
            {icon: 'printer', onClick: print, tooltip: 'Print Report'},
          ]}
        >
          {(Content) =>
            loading ? (
              <Content padding="none">
                <Loader />
              </Content>
            ) : (
              <Content padding="none" noBorder>
                {children}
              </Content>
            )
          }
        </Modal>
      )}
    >
      {children}
    </Print>
  );
};

GasModal.propTypes = {
  children: PropTypes.node,
  gas: PropTypes.object,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

export default GasModal;
